import { fetchDropDownList, fetchDropDownListByDictType } from '@/api/common'
import { fetchCommonPorts } from '@/api/dict'
import { i18n } from '@/plugins/i18n'
import {
  masterCarrierLabel,
  masterCarrierOptions,
} from '@/utils/master-carrier'

type State = {
  product: {
    domain: string
    productCode: string
    formListCode: string
    promptCode: {
      partyOnly: string
      houseBill: string
    }
  }
  dropdown: Partial<Record<string, Dict[]>>
  dropdowMap: {
    [key: string]: { [key: string]: Dict }
  }
}
/**
 * @description:基础信息
 * @return {*}
 */
const useBaseStore = defineStore('base', {
  state: (): State => {
    return {
      product: {
        /** 二级域名匹配的产品 */
        domain: '',
        /** 产品代码 */
        productCode: '',
        /** 表单代码 */
        formListCode: '',
        /** ai提示代码 */
        promptCode: {
          partyOnly: 'MPCI_PARTY_ONLY',
          houseBill: 'MPCI_HOUSE_BILL',
        },
      },
      dropdown: {},
      dropdowMap: {},
    }
  },
  getters: {
    masterCarrierDropdown: (state): Partial<Record<string, Dict[]>> => ({
      masterShipCompany: masterCarrierOptions(
        state.dropdown.shipCompany,
        i18n.global.locale.value,
      ),
      masterShipCompany_common: masterCarrierOptions(
        state.dropdown.shipCompany_common,
        i18n.global.locale.value,
      ),
    }),
    masterCarrierName: (state) => (code: string) => {
      const item = [
        ...(state.dropdown.shipCompany || []),
        ...(state.dropdown.shipCompany_common || []),
      ].find((item) => item.value === code)
      return item ? masterCarrierLabel(item, i18n.global.locale.value) : code
    },
    /** 产品代码 */
    getProductCode: (state) => state.product.productCode || 'product_mpci',
    /** 表单代码 */
    getFormListCode: (state) =>
      state.product.formListCode || 'MPCI-pageListInfo',
    /** 二级域名匹配的产品 */
    getDomain: (state) => state.product.domain || 'mpci',
    /** ai提示代码 */
    getPromptCode: (state) =>
      state.product.promptCode || {
        partyOnly: 'MPCI_PARTY_ONLY',
        houseBill: 'MPCI_HOUSE_BILL',
      },
  },
  actions: {
    async getDropDownListByDictType(dictType: string) {
      const data = await fetchDropDownListByDictType(dictType)
      this.dropdown[dictType] = data
      return data
    },
    async getDropDownList() {
      this.dropdown['movementType'] = [
        {
          label: 'Import',
          value: 'Import',
        },
        {
          label: 'Transit',
          value: 'Transit',
        },
      ]
      const data = await fetchDropDownList()
      Object.keys(data).forEach((key) => {
        const value: Dict[] = []
        const commonValue: Dict[] = []
        const dropdowMap: { [key: string]: Dict } = {}
        data[key as any].forEach((item: Dict) => {
          item.extend = item.extend ? JSON.parse(item.extend) : {}
          item.label = item.dictLabel
          item.value = item.dictCode
          if (item.tag !== 'common') {
            value.push(item)
          } else {
            commonValue.push(item)
          }
          dropdowMap[item.dictValue] = item
        })
        this.dropdown[key as any] = value
        this.dropdown[`${key}_common` as any] = commonValue
        this.dropdowMap[key as any] = dropdowMap
      })

      const MPCI_PORT_LOADING = await fetchCommonPorts('MPCI_PORT_LOADING')
      this.dropdown['MPCI_PORT_LOADING'] = MPCI_PORT_LOADING
      const MPCI_PORT_DISCHARGE = await fetchCommonPorts('MPCI_PORT_DISCHARGE')
      this.dropdown['MPCI_PORT_DISCHARGE'] = MPCI_PORT_DISCHARGE
      const MPCI_PORT_RECEIPT = await fetchCommonPorts('MPCI_PORT_RECEIPT')
      this.dropdown['MPCI_PORT_RECEIPT'] = MPCI_PORT_RECEIPT
      const MPCI_PORT_DELIVERY = await fetchCommonPorts('MPCI_PORT_DELIVERY')
      this.dropdown['MPCI_PORT_DELIVERY'] = MPCI_PORT_DELIVERY
    },
  },
})

export default useBaseStore
